

























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { StoreModel, StoreJson, Address } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { storeService } from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class SaveStoreAddressPage extends Base {
  public storeViewModel: any = {};
  public storeModel: StoreModel = {};
  public storeJson: any = {};
  public address: any = {};
  public form: any = {};
  public storeAddressFields: Array<VFields<any>> = [];
  public storeId: number = 0;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public requestProgress: boolean = false;
  public created(): void {
    this.setAddressFields();
  }

  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'Address' },
        })
        .catch((ex) => {
          console.log(ex);
        });
    }
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, this.$t('stores.address.alertInvalidForm'));
        this.resetMethodName(methodName);
        return;
      }
      this.saveStoreAddress();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }

  public mounted() {
    if (this.$route.params.storeId) {
      this.storeId = Number(this.$route.params.storeId);
      this.getStoreInfo();
    }

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }

  public setAddressFields(): void {
    this.storeAddressFields = [
      {
        key: 'streetAddress1',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t('stores.address.lblStreetAddress1') as string,
          loading: false,
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Street Address 1', v)
          ]
        },
      },
      {
        key: 'streetAddress2',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.address.lblStreetAddress2') as string,
          validations: '',
          loading: false,
          elementClass:'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
        },
      },
      {
        key: 'city',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t('stores.address.lblCity') as string,
          loading: false,
          elementClass:'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('City', v),
            v => this.alphaSpace(v)
          ]
        },
      },
      {
        key: 'state',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.address.lblState') as string,
          loading: false,
          required: true,
          elementClass:'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('State', v),
            v => this.alphaSpace(v)
          ]
        },
      },
      {
        key: 'zip',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          loading: false,
          label: this.$t('stores.address.lblZip') as string,
          required: true,
          elementClass:'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Zip', v),
            v => this.zip(v),
            v => this.zipLength(v)
          ]
        },
      },
    ];
  }

  public updateStore(storeid: number): void {
    this.storeId = storeid;
  }

  public validateAddress(): Vue & { validate: () => boolean } {
    return this.$refs.addressForm as Vue & { validate: () => boolean };
  }

  public async saveStoreAddress(): Promise<void> {
    if(this.validateAddress().validate()){
      var validateRes = this.$validator.errors.items.length > 0;
      if (validateRes) {
        this.showAlert(false, 'Please Enter Valid Details');
        return;
      }

      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        this.storeModel.storeJson.address = this.address;
        if (this.storeModel.id !== 0) {
          const response = await storeService.updateStoreInfo(
            this.storeViewModel,
            this.storeId
          );
          this.storeViewModel = response;
          this.showAlert(
            true,
            this.$t('stores.address.alertStoreAddressUpdated')
          );
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: {
                tenantId: this.tenantId.toString(),
                enterpriseId: this.enterpriseId.toString(),
                storeId: this.storeViewModel.id.toString(),
                tab:'Address'
              },
            })
            .catch((ex) => {
              console.log(ex);
            });
        } else {
          const response = await storeService.saveStoreInfo(this.storeViewModel);
          this.storeViewModel = response;
          this.showAlert(true, this.$t('stores.address.alertStoreAddressSaved'));
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: {
                tenantId: this.tenantId.toString(),
                enterpriseId: this.enterpriseId.toString(),
                storeId: this.storeViewModel.id.toString(),
                tab:'Address'
              },
            })
            .catch((ex) => {
              console.log(ex);
            });
        }
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }

  public async getStoreInfo(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.storeAddressFields);
      const response = await storeService.getStore(this.storeId);
      this.storeViewModel = response;
      this.storeModel.id = this.storeViewModel.id;
      this.storeModel.storeJson = this.storeViewModel.storeJson;
      this.address = this.storeModel.storeJson.address || {
        city: '',
        id: 0,
        state: '',
        streetAddress1: '',
        streetAddress2: '',
        zip: '',
      };
    } finally {
      this.formlyHideSkeleton(this.storeAddressFields);
    }
  }
}
